<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card title="Alterar Senha">
            <b-form @submit="submit" @submit.stop.prevent>
                <!-- Field -->
                <b-form-group
                    label="Senha Atual">
                    <!-- Input -->
                    <b-form-input
                        type="password"
                        v-model="form.password_actual"
                        :state="hasErrors('password_actual', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="password_actual" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Nova Senha">
                    <!-- Input -->
                    <b-form-input
                        type="password"
                        v-model="form.password"
                        :state="hasErrors('password', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="password" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Repita a Nova Senha">
                    <!-- Input -->
                    <b-form-input
                        type="password"
                        v-model="form.password_confirmation"
                        :state="hasErrors('password_confirmation', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="password_confirmation" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Atualizar Senha
                </b-button>
            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
export default {
    props: ['endpointUpdate'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                password_actual: null,
                password: null,
                password_confirmation: null
            }
        }
    },
    methods: {

        submit() {
            this.loading = true;
            axios.put(this.endpointUpdate, this.form)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
